module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/qd-zhangtiefeng-manifesto.e899dfeb.png";